"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGIN_TYPE_LARK = exports.LOGIN_TYPE_DINGDING = exports.LOGIN_TYPE_WECHAT = exports.LOGIN_TYPE_QQ = void 0;
const PREFIX = 'HOME__';
// login method
exports.LOGIN_TYPE_QQ = PREFIX + 'LOGIN_TYPE_QQ';
exports.LOGIN_TYPE_WECHAT = PREFIX + 'LOGIN_TYPE_WECHAT';
exports.LOGIN_TYPE_DINGDING = PREFIX + 'LOGIN_TYPE_DINGDING';
exports.LOGIN_TYPE_LARK = PREFIX + 'LOGIN_TYPE_LARK';
//# sourceMappingURL=home_id.js.map